import React from 'react';

import block from 'propmods';

import './StaticAudio.scss';

const b = block('StaticAudio');

interface Props {
    sources: Array<{ src: string; type: string }>;
}

interface State {
    paused: boolean;
    index: number;
}

class StaticAudio extends React.PureComponent<Props, State> {
    public state = {
        paused: true,
        index: 0,
    };

    private refw = React.createRef<HTMLAudioElement>();
    private get ref() {
        return this.refw.current!;
    }

    public componentDidMount() {
        this.ref.addEventListener('play', this.onPlay);
        this.ref.addEventListener('pause', this.onPause);
        this.ref.addEventListener('ended', this.onEnded);
    }

    public componentWillUnmount() {
        this.ref.removeEventListener('play', this.onPlay);
        this.ref.removeEventListener('pause', this.onPause);
        this.ref.removeEventListener('ended', this.onEnded);
    }

    public render() {
        const { sources = [] } = this.props;
        const { paused, index } = this.state;
        const source = sources.length ? sources[index % sources.length] : null;
        if (!source) {
            return null;
        }

        return (
            <div {...b()} title={paused ? 'Воспроизведение' : 'Пауза'} tabIndex={0}>
                <div {...b('play')} onClick={this.toggle}>
                    <div {...b('play-icon', { paused })} />
                </div>
                <audio ref={this.refw}>
                    <source src={source.src} type={source.type} />
                </audio>
            </div>
        );
    }

    private onPause = () => this.setState({ paused: true });
    private onPlay = () => this.setState({ paused: false });
    private onEnded = () => this.setState({ index: this.state.index + 1 }, () => this.ref.load());

    private toggle = () => {
        this.ref.paused ? void this.ref.play() : this.ref.pause();
    };
}

export default StaticAudio;
